// @flow strict
import React from 'react';
import { getContactHref } from '../../../utils';
import styles from './Author.module.scss';
import { useSiteMetadata } from '../../../hooks';

const Author = () => {
  const { author } = useSiteMetadata();

  return (
    <div className={styles['author']}>
      <p className={styles['author__bio']}>
        {author.name}
        <a
          className={styles['author__bio-twitter']}
          href={getContactHref('discord', author.contacts.discord)}
          rel="noopener noreferrer"
          target="_blank"
        >
          <strong>Sumate a la discusión </strong>
        </a>
      </p>
    </div>
  );
};

export default Author;
